import { useTheme } from '../contexts/ThemeContext'
import { THEME_COLORS, type ThemeColors } from '../config/theme'

export function useThemeColors(): ThemeColors {
  const { theme } = useTheme()
  return THEME_COLORS[theme]
}
